export const OPENCHAT = "OPENCHAT";
export const openingChat = (data) => {
    return {
        type: OPENCHAT,
        payload:data
    }
}